export const ACTIONS = {
  SET_CURRENT_SECTION: "SET_CURRENT_SECTION",
};
